<template> 
    <span class="subscription-badges subscription-badges-bg " :class="`subscription-badges-${props.status}`">
        {{ i18n.t('status.' + props.status) }}    
       
       
    </span> 
</template>
<script setup>
import { defineProps } from 'vue';
import i18n from '@/i18n/index'
const props = defineProps({
    status: {
        type: [String],
        default: null,
    },
});
</script>